// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"index_breadcrumbs_Q3wt3","current":"index_current_MxLqH","arrow":"index_arrow_xCQDp"};